export default __webpack_public_path__ + "static/media/sms-icon.31ffdd45.svg";